import { AfterViewInit, Component, EventEmitter, OnDestroy, OnInit } from '@angular/core';
import { EditBlockBase } from '../../edit-block-base';
import { Subscription } from 'rxjs';
import { FormControl, FormsModule, ReactiveFormsModule, Validators } from '@angular/forms';
import { DurationControlComponent } from "../../../common/components/duration-control/duration-control";
import { MatError, MatFormField, MatFormFieldModule } from "@angular/material/form-field";
import { DurationVerbosePipe } from "../../../common/pipes/duration-verbose";
import { TranslateModule } from "@ngx-translate/core";
import { NgIf } from "@angular/common";
import { MatInput } from "@angular/material/input";
import { CdkTextareaAutosize } from "@angular/cdk/text-field";

@Component({
  selector: 'session-exercice-duration-edit',
  providers: [],
  styleUrls: ['./../component-edit.scss'],
  standalone: true,
  imports: [
    DurationControlComponent,
    MatFormFieldModule,
    MatError,
    DurationVerbosePipe,
    TranslateModule,
    ReactiveFormsModule,
    FormsModule,
    NgIf,
    MatInput,
    CdkTextareaAutosize,
  ],
  templateUrl: './session-exercice-duration-edit.html'
})
export class SessionExerciceDurationEditComponent extends EditBlockBase implements OnInit, AfterViewInit, OnDestroy {

    private subscriptions: Subscription[] = [];
    public repeatMinValue = 1;
    public nbRepeatFormControl: FormControl = new FormControl('1', [
        Validators.required,
        Validators.min(1)
    ]);

    ngOnInit(): void {
        this.nbRepeatFormControl.setValue(this.data.data.sessionItemExercice.nbRepeat);
    }

    ngAfterViewInit(): void {
        this.subscriptions.push(
            this.nbRepeatFormControl.valueChanges.subscribe((value: number) => {
                this.nbRepeatFormControl.markAsTouched();
                if (value < 1) {
                    this.baseComponent.onValuesAreNotGood.emit();
                }else{
                    this.baseComponent.onValuesAreGood.emit();
                }
                this.data.data.sessionItemExercice.nbRepeat = value;

                this.baseComponent.calculateDurations();
                this.baseComponent.onTimeBasedInfoUpdated.emit();
                this.baseComponent.onChanged.emit();
            })
        );
    }

    public onDurationChange(): void {
        this.baseComponent.calculateDurations();
        this.baseComponent.onTimeBasedInfoUpdated.emit();
        this.baseComponent.onChanged.emit();
    }

    public onRestTimeChange(): void {
        this.baseComponent.calculateDurations();
        this.baseComponent.onTimeBasedInfoUpdated.emit();
        this.baseComponent.onChanged.emit();
    }

    public onCommentChange(): void {
        this.baseComponent.onChanged.emit();
    }

    ngOnDestroy(): void {
        this.subscriptions.forEach(subscription => subscription.unsubscribe());
    }
}
